"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeMap = void 0;
/**
 * Simple map implementation that is the same as native Map.
 *
 * IE11 Map is not used because it has inconsistencies with other browsers.
 */
var IkeMap = /** @class */ (function () {
    function IkeMap() {
        this._values = {};
    }
    IkeMap.prototype.get = function (key) {
        return this._values[key];
    };
    IkeMap.prototype.set = function (key, value) {
        this._values[key] = value;
    };
    IkeMap.prototype.has = function (key) {
        return this._values[key] != null;
    };
    IkeMap.prototype.keys = function () {
        return Object.keys(this._values);
    };
    IkeMap.prototype.values = function () {
        var keys = Object.keys(this._values);
        var output = [];
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            output.push(this._values[key]);
        }
        return output;
    };
    IkeMap.prototype.clear = function () {
        this._values = {};
    };
    IkeMap.prototype.delete = function (key) {
        delete this._values[key];
    };
    Object.defineProperty(IkeMap.prototype, "size", {
        get: function () {
            return this.keys().length;
        },
        enumerable: false,
        configurable: true
    });
    return IkeMap;
}());
exports.IkeMap = IkeMap;
//# sourceMappingURL=ike.map.js.map